import { useBackend } from "../../services";

export const useCancelDiscogsImport = () => {
  const { deleteRequest } = useBackend();
  return async () => {
    return await deleteRequest("discogs/import");
  };
};
